import _regeneratorRuntime from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  .form-group {\n    margin-bottom: 0;\n  }\n\n  .send-new-code-btn, .use-diff-method-btn {\n    color: white;\n  }\n\n  .btn-wrapper separator {\n    color: white;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useEffect, useState } from 'react';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import styled from 'styled-components';
import { TwoFactorAuthenticationMethods } from '@tradingblock/types';
import { Views } from '../TwoFactorAuthentication';
import { validateTwoFactorAuthenticationSecurityCode } from '../../../utilities';
import { FormGroup } from '../../basic';
import { TextboxField } from '../../localize/fields';
import PrimaryButton from '../components/PrimaryButton';
;
;
var StyledEnterSecurityCode = styled.div(_templateObject());

var EnterSecurityCode = function EnterSecurityCode(_ref) {
  var selectedVerifiedTwoFactorAuthenticationMethodData = _ref.selectedVerifiedTwoFactorAuthenticationMethodData,
      requestSecurityCode = _ref.requestSecurityCode,
      submitSecurityCode = _ref.submitSecurityCode,
      setCurrentView = _ref.setCurrentView,
      primaryBtnText = _ref.primaryBtnText,
      primaryBtnClassName = _ref.primaryBtnClassName,
      PrimaryBtnIcon = _ref.PrimaryBtnIcon,
      primaryBtnIconClassName = _ref.primaryBtnIconClassName,
      plivoUuid = _ref.plivoUuid,
      isSubmittingTwoFactorAuthenticationSecurityCode = _ref.isSubmittingTwoFactorAuthenticationSecurityCode,
      shouldShowUseDifferentMethodBtn = _ref.shouldShowUseDifferentMethodBtn,
      errorMsg = _ref.errorMsg;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      selectedVerifiedTwoFactorAuthenticationMethodContact = _useState2[0],
      setSelectedVerifiedTwoFactorAuthenticationMethodContact = _useState2[1];

  useEffect(function () {
    if (selectedVerifiedTwoFactorAuthenticationMethodData.twoFaType === TwoFactorAuthenticationMethods.sms) {
      setSelectedVerifiedTwoFactorAuthenticationMethodContact(selectedVerifiedTwoFactorAuthenticationMethodData.phoneNumber);
    } else if (selectedVerifiedTwoFactorAuthenticationMethodData.twoFaType === TwoFactorAuthenticationMethods.email) {
      setSelectedVerifiedTwoFactorAuthenticationMethodContact(selectedVerifiedTwoFactorAuthenticationMethodData.email);
    }
  }, []);
  useEffect(function () {
    requestSecurityCode(selectedVerifiedTwoFactorAuthenticationMethodData.twoFaType);
  }, []);

  var onSubmit =
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(values) {
      var securityCode;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              securityCode = values.securityCode;

              if (selectedVerifiedTwoFactorAuthenticationMethodData.twoFaType === TwoFactorAuthenticationMethods.sms) {
                submitSecurityCode(selectedVerifiedTwoFactorAuthenticationMethodData.twoFaType, securityCode, plivoUuid || '');
              } else if (selectedVerifiedTwoFactorAuthenticationMethodData.twoFaType === TwoFactorAuthenticationMethods.email) {
                submitSecurityCode(selectedVerifiedTwoFactorAuthenticationMethodData.twoFaType, securityCode);
              }

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return React.createElement(StyledEnterSecurityCode, null, React.createElement("p", null, "We sent a security code to ", selectedVerifiedTwoFactorAuthenticationMethodContact, "."), React.createElement(Formik, {
    onSubmit: onSubmit,
    initialValues: {
      securityCode: ''
    },
    validateOnChange: true,
    validationSchema: Yup.object().shape({
      securityCode: Yup.string().trim().test('validityCheck', 'Please enter a valid security code.', function (securityCodeString) {
        return validateTwoFactorAuthenticationSecurityCode(securityCodeString);
      })
    })
  }, React.createElement(Form, {
    translate: undefined
  }, React.createElement(FormGroup, null, React.createElement(Field, {
    component: TextboxField,
    id: "securityCode"
  })), React.createElement("div", {
    className: "mt-1 btn-wrapper"
  }, React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return requestSecurityCode(selectedVerifiedTwoFactorAuthenticationMethodData.twoFaType);
    },
    className: "send-new-code-btn"
  }, "Resend code"), shouldShowUseDifferentMethodBtn && React.createElement(React.Fragment, null, React.createElement("span", {
    className: "ml-1 mr-1 separator"
  }, "|"), React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return setCurrentView(Views.VerifiedMethodSelection);
    },
    className: "use-diff-method-btn"
  }, "Use different method")), React.createElement(PrimaryButton, {
    primaryBtnClassName: primaryBtnClassName,
    btnText: primaryBtnText,
    btnType: "submit",
    PrimaryBtnIcon: PrimaryBtnIcon,
    primaryBtnIconClassName: primaryBtnIconClassName,
    disabled: isSubmittingTwoFactorAuthenticationSecurityCode
  })), errorMsg && React.createElement("p", {
    className: "error mt-3"
  }, errorMsg))));
};

export default EnterSecurityCode;